import React from "react";
import {Col, Row} from "react-bootstrap";

const PageTitle = ({ title, buttons, image, hasSeparator = true }) => {
  return (
    <Row className="mt-3 mb-3">
      <Col>
        <div className="page-title">
          <h2>{image} {title}</h2>
        </div>
      </Col>
      {buttons &&
        <Col className='col-auto text-end align-self-center mb-2'>
          {buttons}
        </Col>
      }
      {hasSeparator &&
        <hr />
      }
    </Row>
  )
};

export default PageTitle;
